// import PiwikProProvider from '@piwikpro/next-piwik-pro';
import Footer, { FooterProps } from 'components/modules/Footer';
import { NavbarLite, NavProps } from 'components/nav/NavBarLite';
import { fetchNavData } from 'components/nav/NavFetching';
import { PropsWithChildren } from 'react';
import getFooterData from 'utils/normalization/footer';
import { GetContentPage } from 'utils/sitemap';
// const PiwikProProvider = require('@piwikpro/next-piwik-pro');

export type LayoutType = {
  navigation: Awaited<ReturnType<typeof fetchNavData>>;
  footer: Awaited<ReturnType<typeof getFooterData>>;
};

interface LayoutDefaultProps {
  footer?: FooterProps;
  navMenu?: NavProps;
  hasFrontpageCarousel?: boolean;
  variants?: Awaited<ReturnType<typeof GetContentPage.allLocales>>;
  pageCategory?: string;
}

const LayoutDefault = ({
  children,
  footer,
  navMenu,
  hasFrontpageCarousel,
  variants,
  pageCategory,
}: PropsWithChildren<LayoutDefaultProps>) => {
  return (
    <>
      {/* <PiwikProProvider
        containerUrl={process.env.NEXT_PUBLIC_CONTAINER_URL}
        containerId={process.env.NEXT_PUBLIC_CONTAINER_ID}
      > */}
      {navMenu && (
        <NavbarLite
          key={hasFrontpageCarousel ? 'transparent-visual' : 'white-visual'}
          navProps={navMenu.navProps}
          megaMenuProps={navMenu.megaMenuProps}
          languageSelectors={navMenu.languageSelectors}
          mainSearch={navMenu.mainSearch}
          isCampaign={navMenu.isCampaign}
          variants={variants}
          hasFrontpageCarousel={hasFrontpageCarousel}
          shouldHideSearch={navMenu.shouldHideSearch}
        />
      )}
      <main id='main-content'>{children}</main>
      {footer && <Footer {...footer} pageCategory={pageCategory} />}
      {/* </PiwikProProvider> */}
    </>
  );
};

export default LayoutDefault;
